var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Exit = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16,5 C16.5522847,5 17,5.44771525 17,6 L17,7 L16,7 L16,6 L7,6 L7,19 L16,19 L16,18 L17,18 L17,19 C17,19.5522847 16.5522847,20 16,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,6 C6,5.44771525 6.44771525,5 7,5 L16,5 Z M17.7843055,9.08859116 L17.8535534,9.14644661 L20.8394113,12.1323045 C21.0199203,12.3128135 21.0399768,12.5930149 20.8995809,12.7956777 L20.8394113,12.8676955 L17.8535534,15.8535534 C17.6582912,16.0488155 17.3417088,16.0488155 17.1464466,15.8535534 C16.9728803,15.679987 16.9535951,15.4105626 17.0885912,15.2156945 L17.1464466,15.1464466 L19.293,13 L11,13 L11,12 L19.293,12 L17.1464466,9.85355339 C16.9728803,9.67998704 16.9535951,9.41056264 17.0885912,9.2156945 L17.1464466,9.14644661 C17.320013,8.97288026 17.5894374,8.95359511 17.7843055,9.08859116 Z" })));
};
Exit.displayName = 'Exit';
export default Exit;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Exit.js.map